import { useMemo } from 'react';
import moment from 'moment/moment';
import { OptionType } from 'components/CustomSelect/types';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';
import { MOMENT_DEFAULT_DATE_FORMAT } from 'utilities';

const useMeasurementDateListOptions =() => {
  const { measurementDates } = useWaterfallContext()

  const options = useMemo<OptionType[]>(() => {
    if (!measurementDates) {
      return []
    }
    return measurementDates.map(measurementDate => ({
      label: moment(measurementDate.date).format(MOMENT_DEFAULT_DATE_FORMAT) ?? '',
      value: measurementDate.id?.toString() || null
    }))
  }, [measurementDates]);

  return {options};
}

export default useMeasurementDateListOptions;